import { getListOfCountries } from 'modules/Auth/actions'
import authSelectors from 'modules/Auth/selectors'
import selector2 from 'modules/Dashboard/selectors'
import {
  checkEmailOtp,
  checkPhoneOtp,
  getNotificationCatalogues,
  getUserPreference,
  sendNotificationEmail,
  SendOtp,
} from 'modules/ManageProfile/actions'
import ManageProfile from 'modules/ManageProfile/index'
import selector from 'modules/ManageProfile/selectors'
import selectors from 'modules/Onboarding/selectors'
import {
  changePassword,
  getStudentData,
  updateStudentData,
  updateStudentProfile,
  getPendingData,
  getFrozenFields,
} from 'modules/Resume/actions'
import { connect } from 'react-redux'
import {
  studentOptedStatus,
  updateOptedStatus,
  updateOptedWitdrawStatus,
} from '../../Dashboard/actions'
const mapStateToProps = state => ({
  UserPreference: selector.getUserPreferenceData(state),
  studentFormData: selectors.getStudentResumeData(state),
  listOfCountries: authSelectors.getListOfCountries(state),
  permissions: authSelectors.getUserPermissions(state),
  optoutStatus: selector2.getOptOutStatus(state),
  pendingData: state.resumeData?.pendingData,
  frozenFields: state.resumeData?.frozenFields,
})

const mapDispatchToProps = {
  getStudentData,
  updateStudentData,
  updateStudentProfile,
  changePassword,
  getUserPreference,
  SendOtp,
  checkEmailOtp,
  checkPhoneOtp,
  getListOfCountries,
  getNotificationCatalogues,
  sendNotificationEmail,
  studentOptedStatus,
  updateOptedStatus,
  updateOptedWitdrawStatus,
  getPendingData,
  getFrozenFields,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageProfile)
